module.exports = __webpack_public_path__ + "img/qrCode.63c756e7.png";